<app-input
  [placeholder]="placeholder"
  [(value)]="value"
  [inputGroup]="formGroup"
  [fieldName]="fieldName"
  [disabled]="disabled"
  [(invalid)]="isInvalid"
  [showError]="showError"
  (onInput)="checkErrors()"
></app-input>
<app-button
  icon="send-white"
  size="medium"
  [disabled]="disabled || isInvalid || emptyField"
  [style]="'filled'"
  (click)="sendMessage()"
>
</app-button>
